import { render, staticRenderFns } from "./serverLanguageService.vue?vue&type=template&id=f6a03568"
import script from "./serverLanguageService.vue?vue&type=script&lang=js"
export * from "./serverLanguageService.vue?vue&type=script&lang=js"
import style0 from "./serverLanguageService.vue?vue&type=style&index=0&id=f6a03568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports